
import { defineComponent } from 'vue'
import { useAccountStore } from '@/store/auth/account.store'
import { useKycStore } from '@/store/auth/kyc.store'
import VeriffVerification from '@/components/VeriffVerification.vue'

export default defineComponent({
  name: 'KycVerification',
  components: {
    VeriffVerification
  },
  data: () => ({
    accountStore: useAccountStore(),
    kycStore: useKycStore(),
    loading: false
  }),
  computed: {
    kycInfo(): any {
      return this.kycStore.kycInfo
    },
    canStartVerification(): boolean {
      return this.kycInfo?.canStartNewVerification === true || !!this.kycInfo?.veriffSessionUrl
    },
    canSkip(): boolean {
      return !this.kycInfo?.verificationRequired
    }
  },
  async mounted() {
    if (this.accountStore.accountData.address?.client?.id) {
      // Un seul appel API via le store Pinia, si la donnée n'est pas déjà chargée
      if (!this.kycInfo) {
        await this.kycStore.fetchKycInfo(this.accountStore.accountData.address.client.id, false)
      }
    }
  },
  methods: {
    // Suppression de loadKycInfo : la récupération se fait uniquement via le store Pinia

    getStatusText(): string {
      // Utiliser latestVerificationStatus pour refléter le statut de la dernière vérification Veriff
      const status = this.kycInfo?.latestVerificationStatus || 'UNKNOWN'
      const statusMap: Record<string, string> = {
        VERIFIED: this.$t('statusVerified') as string,
        APPROVED: this.$t('statusApproved') as string,
        COMPLETED: this.$t('statusCompleted') as string,
        IN_PROGRESS: this.$t('statusInProgress') as string,
        PENDING: this.$t('statusPending') as string,
        SUBMITTED: this.$t('statusSubmitted') as string,
        RESUBMISSION_REQUESTED: this.$t('statusResubmissionRequested') as string,
        DECLINED: this.$t('statusDeclined') as string,
        EXPIRED: this.$t('statusExpired') as string,
        ABANDONED: this.$t('statusAbandoned') as string
      }
      return statusMap[status] || (this.$t('statusUnknown') as string)
    },

    getStatusColor(): string {
      // Utiliser latestVerificationStatus
      const status = this.kycInfo?.latestVerificationStatus
      if (status === 'VERIFIED' || status === 'APPROVED' || status === 'COMPLETED') return 'success'
      if (status === 'PENDING' || status === 'SUBMITTED') return 'info'
      if (status === 'DECLINED' || status === 'EXPIRED') return 'error'
      return 'warning'
    },

    getStatusIcon(): string {
      // Utiliser latestVerificationStatus
      const status = this.kycInfo?.latestVerificationStatus
      if (status === 'VERIFIED' || status === 'APPROVED' || status === 'COMPLETED') return 'mdi-check-circle'
      if (status === 'PENDING' || status === 'SUBMITTED') return 'mdi-clock-outline'
      if (status === 'DECLINED' || status === 'EXPIRED') return 'mdi-close-circle'
      return 'mdi-alert-circle'
    },

    getAlertType(): string {
      // Utiliser latestVerificationStatus
      const status = this.kycInfo?.latestVerificationStatus
      if (status === 'VERIFIED' || status === 'APPROVED' || status === 'COMPLETED') return 'success'
      if (status === 'DECLINED' || status === 'EXPIRED') return 'error'
      return 'info'
    },

    getButtonText(): string {
      if (this.kycInfo?.hasPendingVerification) {
        return this.$t('continueVerification') as string
      }
      return this.$t('startVerification') as string
    },

    handleVerificationSuccess() {
      this.$router.push({ name: 'SendMoney' })
    },

    handleVerificationCanceled() {
      console.log('Vérification annulée')
    },

    skipVerification() {
      this.$router.push({ name: 'SendMoney' })
    }
  }
})
